export default __webpack_public_path__ + "static/media/pattern02.5fea683c.svg";